export default function notificationRun(ngNotify) {

	"ngInject";

	ngNotify
		.addTheme(
			"skatCzytnikiNotification",
			"skat-czytniki-notification"
		);
	ngNotify
		.config({
			theme: "skatCzytnikiNotification",
			duration: 3000,
			type: "info",
			sticky: false,
			html: false
		});

}


// WEBPACK FOOTER //
// ./sources/bootstrap/notification.run.js